module.exports = __webpack_public_path__ + "static/ideou-b5a59aa2e53d4cba5b746144f54eab9b.png";